<template>
  <el-dialog
    v-model="dialogVisible"
    destroy-on-close
    title="导出信息"
    :close-on-click-modal="false"
    class="p-8! pt-4! rounded-lg! box-border custom-dialog"
    :width="380"
    top="38vh"
  >
    <el-form
      ref="ruleFormRef"
      style="max-width: 600px"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
    >
      <el-form-item label="文件名称" prop="fileName">
        <el-input v-model="ruleForm.fileName" placeholder="请输入文件名称" :clearable="false" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer text-center">
        <el-button type="primary" plain @click="dialogVisible = false" class="w-[100px]"
          >取消</el-button
        >
        <el-button type="primary" @click="save" class="w-[100px]"> 导出 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import { computed, ref, reactive, watch } from 'vue'
// 使用计算属性，通过get和set来实现双向绑定
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['update:modelValue', 'submit'])
const ruleForm = reactive({
  fileName: '',
})
const rules = reactive<FormRules<typeof ruleForm>>({
  fileName: [{ required: true, message: '请输入文件名称', trigger: 'blur' }],
})

const dialogVisible = computed({
  get() {
    ruleForm.fileName = ''
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

const ruleFormRef = ref<FormInstance | null>(null)
const save = () => {
  ruleFormRef.value.validate((valid) => {
    if (valid) {
      emit('submit', ruleForm.fileName)
    }
  })
}
</script>
